import {

  Card,

  CardContent,

  Typography,

  Box,

  Grid,

  Chip,

  Divider

} from "@mui/material";

import { BarChart, PieChart } from "@mui/x-charts";


const ProjectsByBoardDashboard = ({ chartDataByBoard }) => {

  if (!chartDataByBoard || !Object.keys(chartDataByBoard).length) {

    return (

      <Box p={4} textAlign="center" bgcolor="white" borderRadius={6} border="1px solid #e2e8f0" mt={3}>

        <Typography color="text.secondary" fontWeight={500}>No data available</Typography>

      </Box>

    );

  }


  // Attractive Rainbow Palette for the Donut Chart tags

  const rainbowPalette = [

    "#FF0000", "#FF7F00", "#FFD700", "#32CD32", "#00CED1", 

    "#1E90FF", "#8A2BE2", "#FF1493", "#00FF7F", "#FF4500"

  ];


  return (

    <Grid item xs={12}>

      <Card

        sx={{

          mt: 3,

          borderRadius: 6,

          height: 650, 

          display: "flex",

          flexDirection: "column",

          boxShadow: "0px 10px 30px rgba(0,0,0,0.04)",

          border: "1px solid #f1f5f9",

        }}

      >

        {/* --- Main Section Header --- */}

        <Box

          sx={{

            px: 4,

            py: 3,

            bgcolor: "white",

            borderBottom: "1px solid #f1f5f9",

            display: 'flex',

            justifyContent: 'space-between',

            alignItems: 'center'

          }}

        >

          <Box>

            <Typography variant="h6" fontWeight={800} color="#1e293b" letterSpacing="-0.5px">

              Projects by Board & Tag

            </Typography>
            <Typography variant="body2" color="text.secondary">Detailed status breakdown per tag across boards</Typography>

          </Box>

          <Chip 

            label={`${Object.keys(chartDataByBoard).length} Boards`} 

            sx={{ fontWeight: 700, bgcolor: '#f1f5f9', color: '#475569' }} 

          />

        </Box>


        <CardContent

          sx={{

            flex: 1,

            overflowY: "auto", 

            p: 0,

            '&::-webkit-scrollbar': { width: '6px' },

            '&::-webkit-scrollbar-thumb': { bgcolor: '#e2e8f0', borderRadius: '10px' }

          }}

        >

          {Object.entries(chartDataByBoard).map(([boardId, { boardName, tags }], index) => (

            <Box 

              key={boardId} 

              sx={{ 

                p: 4, 

                borderBottom: index !== Object.keys(chartDataByBoard).length - 1 ? '8px solid #f8fafc' : 'none' 

              }}

            >

              {/* ✅ Sticky Board Name Label */}

              <Box sx={{ position: 'sticky', top: 0, bgcolor: 'white', zIndex: 1, mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>

                <Typography variant="h6" fontWeight={800} color="#334155">

                  {boardName}

                </Typography>

                <Divider sx={{ flex: 1, borderStyle: 'dashed' }} />

                <Typography variant="caption" sx={{ bgcolor: '#ede7f6', color: '#5e35b1', px: 1.5, py: 0.5, borderRadius: 2, fontWeight: 700 }}>

                  {tags.length} Tags

                </Typography>

              </Box>


              <Grid container spacing={4}>

                {/* LEFT — BAR CHART (Fixed Names & Colors) */}

                <Grid item xs={12} md={7}>

                  <Typography variant="subtitle2" fontWeight={700} color="#64748b" mb={2} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>

                    Project Status Breakdown

                  </Typography>

                  <BarChart

                    layout="horizontal"

                    yAxis={[{

                        scaleType: "band",

                        data: tags.map(t => t.tagName),

                        tickLabelStyle: { fontSize: 13, fontWeight: 600, fill: "#475569" },

                    }]}

                    xAxis={[{ label: "Projects", tickMinStep: 1 }]}

                    series={[

                      {

                        label: "Completed On Time",

                        data: tags.map(t => t.completedWithinTarget),

                        stack: "total",

                        color: "#10b981",

                      },

                      {

                        label: "Completed Late",

                        data: tags.map(t => t.completedAfterTarget),

                        stack: "total",

                        color: "#ef4444",

                      },

                      {

                        label: "Open (Within Due)",

                        data: tags.map(t => t.openWithinDueDate),

                        stack: "total",

                        color: "#f59e0b",

                      },

                      {

                        label: "Open (Overdue)",

                        data: tags.map(t => t.openAfterDueDate),

                        stack: "total",

                        color: "#991b1b",

                      },

                    ]}

                    height={Math.max(tags.length * 60, 250)}

                    margin={{ left: 140 }}

                    slotProps={{

                        legend: { labelStyle: { fontSize: 12, fontWeight: 600 } }

                    }}

                  />

                </Grid>


                {/* RIGHT — DONUT CHART (Rainbow Colors & Improved Legend) */}

                <Grid item xs={12} md={5}>

                  <Box sx={{ 

                      p: 3, 

                      bgcolor: '#f8fafc', 

                      borderRadius: 5, 

                      border: '1px solid #f1f5f9', 

                      display: 'flex', 

                      flexDirection: 'column',

                      alignItems: 'center' 

                  }}>

                    <Typography variant="subtitle2" fontWeight={800} color="#64748b" mb={2} sx={{ textTransform: 'uppercase' }}>

                      Tag Distribution

                    </Typography>

                    

                    <PieChart

                      height={300}

                      series={[{

                          innerRadius: 70,

                          outerRadius: 100,

                          paddingAngle: 3,

                          cornerRadius: 5,

                          arcLabel: () => null,

                          data: tags.map((t, i) => ({

                            id: i,

                            label: t.tagName,

                            value: t.total,

                            color: rainbowPalette[i % rainbowPalette.length]

                          })),

                      }]}

                      margin={{ top: 10, bottom: 80 }}

                      slotProps={{

                        legend: {

                          direction: "row",

                          position: { vertical: "bottom", horizontal: "middle" },

                          labelStyle: { fontSize: 11, fontWeight: 600 },

                          itemGap: 10,

                        },

                      }}

                    />


                    <Typography variant="body2" sx={{ fontWeight: 800, color: "#1e293b", mt: 1 }}>

                      Total Projects: {tags.reduce((sum, t) => sum + t.total, 0)}

                    </Typography>

                  </Box>
                      
                </Grid>

              </Grid>

            </Box>

          ))}

        </CardContent>

      </Card>

    </Grid>  

  );

};


export default ProjectsByBoardDashboard;